// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReferralsHeader_wrapper__LMUOF","referralLogo":"ReferralsHeader_referralLogo__Zs5wZ"};